<template>
    <setting-from></setting-from>
</template>

<script>
import SettingFrom from './_setting_from'
export default {
  components: {
    SettingFrom
  }
}
</script>



// WEBPACK FOOTER //
// src/page/setting/index.vue